import React, { useState } from 'react';
import FooterNav from './FooterNav';

const Connect = ({ onNavigate, isActive, currentPage }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    project: '',
    timeline: '',
    budget: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://formsubmit.co/ajax/aisha@aideaagency.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          company: formData.company,
          project: formData.project,
          timeline: formData.timeline,
          budget: formData.budget,
          _subject: 'New Connect Form Submission - AIDEA Agency'
        })
      });

      if (response.ok) {
        setIsSubmitted(true);
        setFormData({
          name: '',
          email: '',
          company: '',
          project: '',
          timeline: '',
          budget: ''
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="connect" className={`page ${isActive ? 'active' : ''}`}>
      <div className="connect-wrapper">
        <div className="connect-container">
          <div className="connect-intro">
            <h2 className="connect-title">CONNECT</h2>
            <p>Thoughtful brands begin with thoughtful conversations. Whether you're building, evolving, or reimagining your brand, we'd love to connect and explore what we can create together.</p>
            
          </div>
          {isSubmitted ? (
            <div className="form-success">
              <h3>Thank you!</h3>
              <p>We've received your message and will be in touch soon.</p>
              <button
                className="connect-button"
                onClick={() => setIsSubmitted(false)}
              >
                Send Another Message
              </button>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="company">Company</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="project">Project</label>
                <input
                  type="text"
                  id="project"
                  name="project"
                  value={formData.project}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="timeline">Timeline</label>
                <input
                  type="text"
                  id="timeline"
                  name="timeline"
                  value={formData.timeline}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="budget">Budget</label>
                <input
                  type="text"
                  id="budget"
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                />
              </div>
              <button type="submit" className="connect-button" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Connect'}
              </button>
            </form>
          )}
        </div>
      </div>
      <FooterNav onNavigate={onNavigate} currentPage={currentPage} />
    </section>
  );
};

export default Connect;
